export const iconSize = {
  xs: "6px",
  s: "8px",
  m: "12px",
  l: "14px",
  xl: "16px",
  xxl: "18px",
  xxxl: "20px",
  huge: "32px",
};
